'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@svs/ui/react/button';
import type { ReactNode } from 'react';
type DownloadExternalFileProps = {
  rows: string[];
  fileName: string;
};

/**
 * Client component for downloading external system file.
 *
 * @param root0 component props
 * @param root0.rows row data to write to file
 * @param root0.fileName output filename
 * @returns download button
 */
export function DownloadExternalFile(t0) {
  const $ = _c(3);
  const {
    rows,
    fileName
  } = t0;
  let t1;
  if ($[0] !== fileName || $[1] !== rows) {
    const handleClick = () => {
      if (rows.length === 0) {
        return;
      }
      const content = rows.join("\r\n");
      const base64Rows = window.btoa(content);
      const link = document.createElement("a");
      link.href = `data:application/octet-stream;charset:UTF-8;base64,${base64Rows}`;
      link.download = fileName;
      link.click();
    };
    t1 = <Button variant="ghost" onClick={handleClick}>Ladda ned fil</Button>;
    $[0] = fileName;
    $[1] = rows;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}